/**
 * Знак ЯНяни «День» (docs/brand): утро, день — вечер, ночь в одной плитке.
 *
 * Картинкой, а не иконкой набора: знак векторный и собирается скриптом
 * `tools/brand/build.py` вместе с фавиконом, поэтому в приложении он ровно
 * тот же, что в брендбуке. Цвета живут в самом файле: клетки знака по его
 * правилам не перекрашиваются, так что токены темы к ним не относятся.
 */

import clsx from 'clsx'
import type { CSSProperties } from 'react'

import markUrl from '@/shared/brand/mark.svg'

export function BrandMark({
  size = 88,
  className,
  style,
}: {
  /** Сторона в пикселях. Меньше 20 знак не ставим — там нужен favicon.svg. */
  size?: number
  className?: string
  style?: CSSProperties
}) {
  return (
    <img
      // Декоративен: рядом всегда стоит название «ЯНяня».
      alt=""
      aria-hidden
      src={markUrl}
      width={size}
      height={size}
      draggable={false}
      className={clsx('block shrink-0 select-none', className)}
      style={{ width: size, height: size, ...style }}
    />
  )
}
